import(/* webpackMode: "eager" */ "/codebuild/output/src1804432208/src/chanceeakin.io-2024/src/components/content/home.tsx")